import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

export const body: ModelConfigParams = {
  bodyParts: [
    'kidney',
    'collectingLeftRight',
    'arteryWithUncertain',
    'veinWithUncertain',
    'spleen',
    'gallBladder',
    'adrenalGland',
    'oesophagus',
    'thyroid',
    'sacrum',
    'heart',
    'aorta',
    'bone',
    'liver',
    'skin',
    'bodyFat',
    'stomach',
    'abdo',
    'bladder',
    'tumour',
    'lung',
    'prostate',
    'portalVein',
    'psoas',
    'abdoTransverse',
    'bowel',
    'pancreas',
    'renalSinusFat',
    'calcification',
    'biliarySystem',
    'colon',
    'lymph',
    'fistula',
    'nerveColorectal',
    'mesorectum',
    'rectum',
    'pelvicBones',
    'ovary',
    'sphincter',
    'uterus',
    'vagina',
  ],
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [-300, 300],
  internal: true,
}
